import { type HighlightsController } from '@databases/highlights';
import { createFillPreviewEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface FillPreviewEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createFillPreviewEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FILL_PREVIEW_EFFECT,
    type: 'effect',
    // Always active — the fill preview shows a dashed box during
    // fill drag operations and is part of core selection rendering.
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFillPreviewEffect(highlightsController);
    },
  };
}
